import { useEffect, useState } from "react";
import { EADDRESS_TYPES } from "@constants";
import { getContactAddressRoute } from "@api-routes";
import { useFetch } from "./useFetch";
import { IUserAddress } from "@common/eircode/Interface/IAddressForm";

export const useGetAddressType = (addressType: EADDRESS_TYPES) => {
    const [addressField, setAddressField] = useState<IUserAddress>();

    const [getUserAddressState, { get }] = useFetch();

    const getUserAddress = () => {
        get<IUserAddress>(getContactAddressRoute(addressType)).then((contactAddressResponse) => {
            if (contactAddressResponse) {
                setAddressField(contactAddressResponse);
            }
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getUserAddress, []);

    return { getUserAddress, getUserAddressState, addressField };
};
